/**
* @file storelocator.js
*
* Store Locator
*
* by: Caleb Bodtorf
* © 2018
*/

var mapStyle = [
  {
    "elementType": "labels.icon",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "administrative",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#000000"
      }
    ]
  },
  {
    "featureType": "administrative.country",
    "elementType": "geometry.stroke",
    "stylers": [
      {
        "color": "#ffe0e8"
      }
    ]
  },
  {
    "featureType": "administrative.province",
    "elementType": "geometry.stroke",
    "stylers": [
      {
        "color": "#ffe0e8"
      },
      {
        "saturation": -40
      },
      {
        "lightness": -20
      }
    ]
  },
  {
    "featureType": "landscape",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#fff4f7"
      },
      {
        "saturation": -100
      },
      {
        "lightness": 70
      }
    ]
  },
  {
    "featureType": "poi.attraction",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "poi.attraction",
    "elementType": "geometry",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "poi.business",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "poi.government",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "poi.medical",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "poi.park",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "color": "#ffe0e8"
      }
    ]
  },
  {
    "featureType": "poi.park",
    "elementType": "labels",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "poi.park",
    "elementType": "labels.text",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "poi.place_of_worship",
    "elementType": "geometry",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "poi.school",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "poi.sports_complex",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "road.arterial",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "color": "#ffe0e8"
      },
      {
        "saturation": -100
      },
      {
        "lightness": -5
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "color": "#D4B5BE"
      },
      {
        "lightness": -15
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "geometry.stroke",
    "stylers": [
      {
        "color": "#D4B5BE"
      },
      {
        "saturation": -70
      },
      {
        "lightness": 70
      },
      {
        "visibility": "on"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "labels.icon",
    "stylers": [
      {
        "saturation": -15
      },
      {
        "visibility": "on"
      }
    ]
  },
  {
    "featureType": "road.local",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "color": "#ffe0e8"
      },
      {
        "saturation": -100
      }
    ]
  },
  {
    "featureType": "water",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "saturation": -60
      }
    ]
  }
]

var map;
var markers = [];
var data = {};
var infoWindow;
var locationList;
var dataUrl = "/" + document.querySelector(['script[data-id="proxy-url"]']).getAttribute('data-proxy-url') + "/locations";
var iconUrl = "https://cdn.shopify.com/s/files/1/0004/7130/2163/files/GiGi_Logos_Seal.png?11513063441452820794"

// Escapes HTML characters in a template literal string, to prevent XSS.
// See https://www.owasp.org/index.php/XSS_%28Cross_Site_Scripting%29_Prevention_Cheat_Sheet#RULE_.231_-_HTML_Escape_Before_Inserting_Untrusted_Data_into_HTML_Element_Content
function sanitizeHTML(strings) {
  var entities = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
  var result = strings[0];
  for (var i = 1; i < arguments.length; i++) {
    result += String(arguments[i]).replace(/[&<>'"]/g, function (char) {
      return entities[char];
    });
    result += strings[i];
  }
  return result;
}

/**
* Initiate google maps
*/
function initMap() {
  var mapElement = document.getElementsByClassName('map')[0];
  var locationElement = document.getElementById('locationMap');

  if (mapElement !== undefined) {
    initStoreLocator(mapElement);
  } else if (locationElement) {
    initLocationLanding(locationElement);
  }
}

/**
* Init Store Locator
* @param { Element } element
*/
function initStoreLocator(element) {
  // Create the map.
  map = new google.maps.Map(element, {
    zoom: 4,
    center: {lat: 37.09024, lng: -95.712891},
    styles: mapStyle
  });

  // Define location List
  locationList = document.getElementById("locationList");

  // Load the stores geoJSON onto the map
  loadGeoJSON(dataUrl);

  // Create info window for google maps
  infoWindow = new google.maps.InfoWindow();
  infoWindow.setOptions({pixelOffset: new google.maps.Size(0, -30)});

  // Add click event to search button
  searchButton = document.getElementById("searchButton").onclick = searchLocations;

  // Override zoom so we don't zoom in too far when calling map.fitBounds
  google.maps.event.addListener(map, 'zoom_changed', function() {
    zoomChangeBoundsListener =
      google.maps.event.addListener(map, 'bounds_changed', function(event) {
        if (this.getZoom() > 15) {
          // Change max/min zoom here
          this.setZoom(15);
        }
      google.maps.event.removeListener(zoomChangeBoundsListener);
    });
  });

  // Autocomplete
  var input = document.getElementById('searchTextField');
  var options = {
    types: ['(cities)'],
    componentRestrictions: {country: 'us'}
  };

  autocomplete = new google.maps.places.Autocomplete(input, options);
  input.addEventListener("keyup", function(event) {
    // Cancel the default action, if needed
    event.preventDefault();
    // Number 13 is the "Enter" key on the keyboard
    if (event.keyCode === 13) {
      // Trigger the button element with a click
      document.getElementById("searchButton").click();
    }
  });

  if (window.location.pathname === "/pages/stores-in-store-pickup") {
    document.addEventListener("keyup", function(event) {
      // Cancel the default action, if needed
      event.preventDefault();
      // Number 13 is the "Enter" key on the keyboard
      if (event.keyCode === 13) {
        // Trigger the button element with a click
        document.getElementById("searchButton").click();
      }
    });
  }

}

/**
* Init Location Landing
* @param { Element } element
*/
function initLocationLanding(element) {
  // Create the map.
  map = new google.maps.Map(element, {
    zoom: 4,
    center: {lat: 37.09024, lng: -95.712891},
    styles: mapStyle
  });

  // Define location List
  locationList = document.getElementById("locationList");

  var storeNumber = document.getElementById("storeNumber");

  // Load the stores geoJSON onto the map
  loadGeoJSON(dataUrl + "/" + storeNumber.textContent);

  // Create info window for google maps
  infoWindow = new google.maps.InfoWindow();
  infoWindow.setOptions({pixelOffset: new google.maps.Size(0, -30)});
}

/**
* Load geoJSON data from API
* @param { String } url
*/
function loadGeoJSON(url) {
  $.get(url)
    .then(function(res){
      data = res;
      res.features.forEach(function(feature, i){
        var latlng = new google.maps.LatLng(
             parseFloat(feature.geometry.coordinates[1]),
             parseFloat(feature.geometry.coordinates[0]));

        createMarker(latlng, feature);
        if (document.getElementById("storeNumber")) {
          createListItemLanding(feature, i, latlng)
        } else {
          createListItem(feature, i, latlng);
        }
        locationList.style.visibility = "visible";
      })
    });
}

/**
* Search locations and geocode valid values.
*/
function searchLocations() {
  var address = document.getElementById("searchTextField").value;
  var geocoder = new google.maps.Geocoder();
  geocoder.geocode({address: address}, function(results, status) {
    if (status == google.maps.GeocoderStatus.OK) {
     searchLocationsNear(results[0].geometry.location);
    } else {
      zoomOut();
    }
  });
}

/**
* Clear Locations from the list
*/
function clearLocations() {
  infoWindow.close();

  locationList.innerHTML = "";
  var msg = document.createElement("DIV");
  msg.innerHTML = "See all results:";
  locationList.appendChild(msg);
}

/**
* Search all locations near a center point. In our case from a search result.
* @param { Google geocoder.geocode result } center
*/
function searchLocationsNear(center) {
  clearLocations();

  var radius = document.getElementById('radiusSelect').value;
  var bounds = new google.maps.LatLngBounds();
  var locationsInBoundCount = 0

  data.features.forEach(function(feature, i){
    var lat = feature.geometry.coordinates[1]
    var lng = feature.geometry.coordinates[0]

    if (arePointsNear({lat: lat, lng: lng}, {lat: center.lat(), lng: center.lng()}, radius)) {
      var latlng = new google.maps.LatLng(
          parseFloat(lat),
          parseFloat(lng));

      createListItem(feature, i);
      bounds.extend(latlng);
      locationsInBoundCount++
    }
  })

  if (locationsInBoundCount > 0) {
    map.fitBounds(bounds);
  } else {
    noResultsZoomOut()
  }
}

/**
* Create a list item for Store Locator
* @param { geoJSON Feature } feature
* @param { Number } num
* @param { google.maps.LatLng } latlng
*/
function createListItem(feature, num, latlng) {
  console.log(feature)
  var name = feature.properties.name;
  var hours = feature.properties.hours.split('\n').map(function(el,idx,arr){
    if (idx < arr.length - 1) {
      var wdayHours = el.split(',');
      var wday = wdayHours[0];
      var is_operational = wdayHours[1] === 'true' ? true : false;
      var opens = wdayHours[2];
      var closes = wdayHours[3];
      var hrs = is_operational ? (opens + " - " + closes) : "closed"
      return (wday + ": " + hrs)
    }
  });
  var phone = feature.properties.phone;
  var storeEmail = feature.properties.store_email;
  var address1 = feature.properties.address1;
  var address2 = feature.properties.address2;
  var city = feature.properties.city;
  var state = feature.properties.state;
  var postalCode = feature.properties.postalCode;
  var externalUrl = feature.properties.externalUrl.includes('http') ? feature.properties.externalUrl : null;
  var url = document.createElement('a');
  url.href = feature.properties.landingPageUrl;
  var landingPageUrl = feature.properties.landingPageUrl ? (window.location.origin + url.pathname) : null;
  var landingPageText = "See "+ name +"'s page";
  var status = feature.properties.status;
  var btnText = function() {
    if (status === "OPEN") {
      if (externalUrl) {
        return "Order for pickup"
      } else {
        return "Order for pickup"
      }
    } else if (status === "COMING_SOON") {
      return "Store coming soon"
    } else if (status === "CLOSED") {
      return "Store closed"
    }
  }();
  var socialLinks = ["yelpUrl", "facebookUrl", "instagramUrl", "pinterestUrl", "twitterUrl"].map(function(link, index){
    if (feature.properties[link].includes('http')) {
      return {
        name: link.split('Url')[0],
        link: feature.properties[link],
      }
    } else {
      return null;
    }
  });
  var content = sanitizeHTML`
      <div class="item-icon-wrapper">
        <img src="${ iconUrl }"/>
      </div>

      <div class="item-content-wrapper" data-status="${status}">
        <h6 class="location-name">${name}</h6>
        <p class="location-page">
          <a ${landingPageUrl ? (`href=${landingPageUrl}`) : "disabled"}>${landingPageUrl ? landingPageText : ''}</a>
        </p>
        <div>
          <p>
            ${address1} ${address2}</br>
            ${city}, ${state} ${postalCode}
          </p>
        </div>
        <div>
          <a ${externalUrl ? (`href=${externalUrl}`) : "disabled"} rel="noopener noreferrer" target="_blank"><button class="btn ${status === 'OPEN' ? 'btn--dark' : ''} btn--flat"><span>${btnText}</span></button></a>
        </div>
        <div class="additional-details">
          <span class="details-dropdown-trigger">Phone and Hours +</span>
          <div class="details-dropdown">
            <p>
              <a href="tel:${phone}" class="details-phone"><b>Phone:</b> ${phone}</a><br/>
              <a class="${storeEmail ? '' : 'hide'}" href="mailto:${storeEmail}" class="details-phone"><b>Email:</b> <small>${storeEmail}</small></a><br/>
              
              </br>
              ${hours[0]}</br>
              ${hours[1]}</br>
              ${hours[2]}</br>
              ${hours[3]}</br>
              ${hours[4]}</br>
              ${hours[5]}</br>
              ${hours[6]}</br>
              </br>
              <div class="social-links socials">
                <ul>
                  <li><a href='${socialLinks[0] !== null ? socialLinks[0].link : '#'}' class='social-icon social_fa-${socialLinks[0] !== null ? socialLinks[0].name : ' hide'}' rel="noopener noreferrer" target="_blank"><i class='fa fa-${socialLinks[0] !== null ? socialLinks[0].name : ' hide'}' aria-hidden='true'></i></a></li>
                  <li><a href='${socialLinks[1] !== null ? socialLinks[1].link : '#'}' class='social-icon social_fa-${socialLinks[1] !== null ? socialLinks[1].name : ' hide'}' rel="noopener noreferrer" target="_blank"><i class='fa fa-${socialLinks[1] !== null ? socialLinks[1].name : ' hide'}' aria-hidden='true'></i></a></li>
                  <li><a href='${socialLinks[2] !== null ? socialLinks[2].link : '#'}' class='social-icon social_fa-${socialLinks[2] !== null ? socialLinks[2].name : ' hide'}' rel="noopener noreferrer" target="_blank"><i class='fa fa-${socialLinks[2] !== null ? socialLinks[2].name : ' hide'}' aria-hidden='true'></i></a></li>
                  <li><a href='${socialLinks[3] !== null ? socialLinks[3].link : '#'}' class='social-icon social_fa-${socialLinks[3] !== null ? socialLinks[3].name : ' hide'}' rel="noopener noreferrer" target="_blank"><i class='fa fa-${socialLinks[3] !== null ? socialLinks[3].name : ' hide'}' aria-hidden='true'></i></a></li>
                  <li><a href='${socialLinks[4] !== null ? socialLinks[4].link : '#'}' class='social-icon social_fa-${socialLinks[4] !== null ? socialLinks[4].name : ' hide'}' rel="noopener noreferrer" target="_blank"><i class='fa fa-${socialLinks[4] !== null ? socialLinks[4].name : ' hide'}' aria-hidden='true'></i></a></li>
                </ul>
              </div>
            </p>
          </div>
        </div>
      </div>
    `;
  var listItem = document.createElement('DIV');
  listItem.classList.add('map-list-item');
  listItem.setAttribute('data-id', num);
  listItem.innerHTML = content;
  locationList.appendChild(listItem);
  listItem.querySelector('.details-dropdown-trigger').addEventListener('click', function(evt) {
    this.nextElementSibling.classList.toggle("show")
  })

  var locationElement = document.getElementById('locationMap');

  if (locationElement) {
    var btnLinkElement = document.getElementById('btnLink');
    var btnTextElement = document.getElementById('btnText');

    if (externalUrl) {
      btnLinkElement.setAttribute('href', externalUrl);
    } else {
      btnLinkElement.setAttribute('disabled', true);
    }

    if (status === "OPEN") {
      btnTextElement.classList.add('btn--dark');
    }

    btnTextElement.textContent = btnText;
  }

  listItem.addEventListener('click', function() {
    google.maps.event.trigger(markers[this.getAttribute('data-id')], 'click');
  })
}

/**
* Create a list item for Landing Page
* @param { geoJSON Feature } feature
* @param { Number } num
* @param { google.maps.LatLng } latlng
*/
function createListItemLanding(feature, num, latlng) {
  console.log(feature)
  var name = feature.properties.name;
  var hours = feature.properties.hours.split('\n').map(function(el,idx,arr){
    if (idx < arr.length - 1) {
      var wdayHours = el.split(',');
      var wday = wdayHours[0];
      var is_operational = wdayHours[1] === 'true' ? true : false;
      var opens = wdayHours[2];
      var closes = wdayHours[3];
      var hrs = is_operational ? (opens + " - " + closes) : "closed"
      return (wday + ": " + hrs)
    }
  });
  var phone = feature.properties.phone;
  var storeEmail = feature.properties.store_email;
  var address1 = feature.properties.address1;
  var address2 = feature.properties.address2;
  var city = feature.properties.city;
  var state = feature.properties.state;
  var postalCode = feature.properties.postalCode;
  var externalUrl = feature.properties.externalUrl.includes('http') ? feature.properties.externalUrl : null;
  var status = feature.properties.status;
  var btnText = function() {
    if (status === "OPEN") {
      if (externalUrl) {
        return "Order for pickup"
      } else {
        return "Order for pickup"
      }
    } else if (status === "COMING_SOON") {
      return "Store coming soon"
    } else if (status === "CLOSED") {
      return "Store closed"
    }
  }();
  var socialLinks = ["yelpUrl", "facebookUrl", "instagramUrl", "pinterestUrl", "twitterUrl"].map(function(link, index){
    if (feature.properties[link].includes('http')) {
      return {
        name: link.split('Url')[0],
        link: feature.properties[link],
      }
    } else {
      return null;
    }
  });
  var content = sanitizeHTML`
      <div class="item-icon-wrapper">
        <img src="${ iconUrl }"/>
      </div>

      <div class="item-content-wrapper" data-status="${status}">
        <div>
          <p class="details-address">
            ${address1} ${address2}</br>
            ${city}, ${state} ${postalCode}
          </p>
        </div>
        <div class="additional-details">
          <div class="details-dropdown">
            <p>
              <a href="tel:${phone}" class="details-phone"><b>Phone:</b> ${phone}</a><br/>
              <a class="${storeEmail ? '' : 'hide'}" href="mailto:${storeEmail}" class="details-phone"><b>Email:</b> <small>${storeEmail}</small></a><br/>
              </br>
              ${hours[0]}</br>
              ${hours[1]}</br>
              ${hours[2]}</br>
              ${hours[3]}</br>
              ${hours[4]}</br>
              ${hours[5]}</br>
              ${hours[6]}</br>
              </br>
              <div class="social-links socials">
                <ul>
                  <li><a href='${socialLinks[0] !== null ? socialLinks[0].link : '#'}' class='social-icon social_fa-${socialLinks[0] !== null ? socialLinks[0].name : ' hide'}' rel="noopener noreferrer" target="_blank"><i class='fa fa-${socialLinks[0] !== null ? socialLinks[0].name : ' hide'}' aria-hidden='true'></i></a></li>
                  <li><a href='${socialLinks[1] !== null ? socialLinks[1].link : '#'}' class='social-icon social_fa-${socialLinks[1] !== null ? socialLinks[1].name : ' hide'}' rel="noopener noreferrer" target="_blank"><i class='fa fa-${socialLinks[1] !== null ? socialLinks[1].name : ' hide'}' aria-hidden='true'></i></a></li>
                  <li><a href='${socialLinks[2] !== null ? socialLinks[2].link : '#'}' class='social-icon social_fa-${socialLinks[2] !== null ? socialLinks[2].name : ' hide'}' rel="noopener noreferrer" target="_blank"><i class='fa fa-${socialLinks[2] !== null ? socialLinks[2].name : ' hide'}' aria-hidden='true'></i></a></li>
                  <li><a href='${socialLinks[3] !== null ? socialLinks[3].link : '#'}' class='social-icon social_fa-${socialLinks[3] !== null ? socialLinks[3].name : ' hide'}' rel="noopener noreferrer" target="_blank"><i class='fa fa-${socialLinks[3] !== null ? socialLinks[3].name : ' hide'}' aria-hidden='true'></i></a></li>
                  <li><a href='${socialLinks[4] !== null ? socialLinks[4].link : '#'}' class='social-icon social_fa-${socialLinks[4] !== null ? socialLinks[4].name : ' hide'}' rel="noopener noreferrer" target="_blank"><i class='fa fa-${socialLinks[4] !== null ? socialLinks[4].name : ' hide'}' aria-hidden='true'></i></a></li>
                </ul>
              </div>
              <div>
                <a ${externalUrl ? (`href=${externalUrl}`) : "disabled"} rel="noopener noreferrer" target="_blank"><button class="btn ${status === 'OPEN' ? 'btn--dark' : ''} btn--flat"><span>${btnText}</span></button></a>
              </div>
            </p>
          </div>
        </div>
      </div>
    `;
  var listItem = document.createElement('DIV');
  listItem.classList.add('map-list-item');
  listItem.setAttribute('data-id', num);
  listItem.innerHTML = content;
  locationList.appendChild(listItem);

  var locationElement = document.getElementById('locationMap');

  if (locationElement) {
    var btnLinkElement = document.getElementById('btnLink');
    var btnTextElement = document.getElementById('btnText');

    if (externalUrl) {
      btnLinkElement.setAttribute('href', externalUrl);
    } else {
      btnLinkElement.setAttribute('disabled', true);
    }

    if (status === "OPEN") {
      btnTextElement.classList.add('btn--dark');
    }

    btnTextElement.textContent = btnText;

    map.setCenter(latlng);
    map.setZoom(13);
  }
}


/**
* Create a Map Marker
* @param { google.maps.LatLng } latlng
* @param { geoJSON Feature } feature
*/
function createMarker(latlng, feature) {
  var marker = new google.maps.Marker({
    map: map,
    position: latlng,
    icon: {
      url: iconUrl,
      scaledSize: new google.maps.Size(32, 32)
    }
 });

  google.maps.event.addListener(marker, 'click', function() {

    var category = feature.properties.category;
    var name = feature.properties.name;
    var hours = feature.properties.hours.split('\n').map(function(el,idx,arr){
      if (idx < arr.length - 1) {
        var wdayHours = el.split(',');
        var wday = wdayHours[0];
        var is_operational = wdayHours[1] === 'true' ? true : false;
        var opens = wdayHours[2];
        var closes = wdayHours[3];
        var hrs = is_operational ? (opens + " - " + closes) : "closed"
        return (wday + ": " + hrs)
      }
    });
    var phone = feature.properties.phone;
    var storeEmail = feature.properties.store_email;
    var position = latlng;
    var address1 = feature.properties.address1;
    var address2 = feature.properties.address2;
    var city = feature.properties.city;
    var state = feature.properties.state;
    var postalCode = feature.properties.postalCode;
    var externalUrl = feature.properties.externalUrl.includes('http') ? feature.properties.externalUrl : null;
    var url = document.createElement('a');
    url.href = feature.properties.landingPageUrl;
    var landingPageUrl = feature.properties.landingPageUrl ? (window.location.origin + url.pathname) : null;
    var landingPageText = "See "+ name +"'s page";
    var status = feature.properties.status;
    var btnText = function() {
      if (status === "OPEN") {
        if (externalUrl) {
          return "Order for pickup"
        } else {
          return "Order for pickup"
        }
      } else if (status === "COMING_SOON") {
        return "Store coming soon"
      } else if (status === "CLOSED") {
        return "Store closed"
      }
    }();
    var content = sanitizeHTML`
      <div style="margin-bottom:20px;">
        <h6 class="location-name">${name}</h6>
        <p class="location-page">
          <a ${landingPageUrl ? (`href=${landingPageUrl}`) : "disabled"}>${landingPageUrl ? landingPageText : ''}</a>
        </p>
        <div>
          <p>
            ${address1} ${address2}</br>
            ${city}, ${state} ${postalCode}
          </p>
        </div></br>
        <div>
          <a ${externalUrl ? (`href=${externalUrl}`) : "disabled"} rel="noopener noreferrer" target="_blank"><button class="btn ${status === 'OPEN' ? 'btn--dark' : ''} btn--flat"><span>${btnText}</span></button></a>
        </div></br>
        <p>
          <b>Phone:</b> ${phone}</br>
          
          <b class="${storeEmail ? '' : 'hide'}">Email:</b> <small>${storeEmail}</small><br/>
          </br>
          ${hours[0]}</br>
          ${hours[1]}</br>
          ${hours[2]}</br>
          ${hours[3]}</br>
          ${hours[4]}</br>
          ${hours[5]}</br>
          ${hours[6]}</br>
        </p>
      </div>
    `;

    infoWindow.setContent(content);
    infoWindow.open(map, marker);
  });
  markers.push(marker);
 }

/**
* Checks to see if point is within radius in kilometers of another point.
* @param { Object } checkPoint
* @param { Object } centerPoint
* @param { Number } km
*/
function arePointsNear(checkPoint, centerPoint, km) {
  var ky = 40000 / 360;
  var kx = Math.cos(Math.PI * centerPoint.lat / 180.0) * ky;
  var dx = Math.abs(centerPoint.lng - checkPoint.lng) * kx;
  var dy = Math.abs(centerPoint.lat - checkPoint.lat) * ky;
  return Math.sqrt(dx * dx + dy * dy) <= km;
}

/**
* Zooms out when no results. And shows error message.
*/
function noResultsZoomOut() {
  // No Results
  zoomOut()

  locationList.innerHTML = "";
  var msg = document.createElement("DIV");
  msg.innerHTML = "No locations within your search radius.";
  locationList.appendChild(msg);
}

/**
* Zooms out to full USA map.
*/
function zoomOut() {
  var latlng = new google.maps.LatLng(
      parseFloat(37.09024),
      parseFloat(-95.712891));
  map.setZoom(4);
  map.setCenter(latlng);
}
